export default "__VITE_ASSET__CrQEQpo3__";